import { theme as antdTheme, type ThemeConfig } from 'antd';

import { themeTokens } from './tokens';

import { ETheme } from '../model/types';

export function createAntdTheme(mode: ETheme): ThemeConfig {
  const isDark = mode === ETheme.dark;
  const colors = themeTokens[mode];

  return {
    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      // Primary colors
      colorPrimary: colors.primary,
      colorPrimaryHover: colors.primary_light,
      colorPrimaryActive: colors.primary_dark,

      // Background colors
      colorBgContainer: colors.bg_primary,
      colorBgLayout: colors.bg_root,
      colorBgElevated: colors.light_gray_1,

      // Text colors
      colorText: colors.black_1,
      colorTextSecondary: colors.gray_1,
      colorTextTertiary: colors.gray_2,

      // Border colors
      colorBorder: colors.gray_3,
      colorBorderSecondary: colors.light_gray_2,

      // Status colors
      colorSuccess: colors.successful_1,
      colorError: colors.red_1,
      colorWarning: colors.processing_1,
      colorInfo: isDark ? colors.light_blue_1 : colors.blue_1,

      // Border radius
      borderRadius: 8,
      borderRadiusLG: 12,
      borderRadiusSM: 6,

      // Font
      fontFamily: 'SF Pro Text, -apple-system, sans-serif',
    },
    components: {
      Button: {
        primaryShadow: 'none',
        defaultShadow: 'none',
        dangerShadow: 'none',
      },
      Modal: {
        contentBg: colors.bg_primary,
        headerBg: colors.bg_primary,
      },
      Dropdown: {
        colorBgElevated: colors.light_gray_1,
      },
      Tooltip: {
        colorBgSpotlight: colors.light_gray_2,
      },
    },
  };
}
